import { ReadonlyVec3, vec2 } from 'gl-matrix';
import { atom, atomFamily } from 'recoil';
import { CurveData } from '~/components/Charts/DVHLineChart';
import { DoseSummationType, DoseType } from '~/domain/dicom/dicomDose';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { DEFAULT_DOSE_OPACITY_VALUE } from '~/engine/data/dose/DoseDistribution';
import { DoseTargetData } from '~/utils/transforms/doseTargetsTransforms';

export const doseScaleState = atom<number>({
    key: 'doseScaleState',
    default: 1.0,
});

export const doseVisibilityState = atom<boolean>({
    key: 'doseVisibilityState',
    default: true,
});

export const doseOpacityState = atom<number>({
    key: 'doseOpacityState',
    default: DEFAULT_DOSE_OPACITY_VALUE,
});

export const currentDoseState = atom<DoseMatrix | undefined>({
    key: 'currentDoseState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export type DoseData = {
    id: string;
    sopUid: string;
    normalizationValueGy: number;
    dvhs: CurveData[];
    type: DoseType;
    summationType: DoseSummationType;
    doseGridResolution: ReadonlyVec3;
    planLabel?: string;
    generated: boolean;
    selectedRange: vec2;
    maxDoseGy: number;
    manufacturer: string;
    manufacturerModelName: string;
    seriesDescription: string;
    doseComment: string;
    softwareVersions: string;
    targets?: DoseTargetData[];
};

export const doseDataState = atomFamily<DoseData | undefined, string>({
    key: 'doseDataState',
    default: undefined,
});
